import { DataAPILogState, DataAPIState } from './reducers';

export const getDataAPIState = (state): DataAPIState => state.dataAPI;
export const getBaasAppId = (state) =>
  getDataAPIState(state).baasApp ? getDataAPIState(state).baasApp.getAppId() : null;
export const getDataAPILogState = (state): DataAPILogState => state.dataAPI.logs;
